<script setup lang="jsx">
    import Sidebar from '@/components/siderbar/SidebarComponent';
    import { sidebarWidth } from '@/components/siderbar/state';
    import { isNullOrEmpty, isEmail, isPhoneNumber, isValidatePassword, toCamelCase, toDateFormat, formatCurrency } from '@/composables/utils';
    import { apiUrl } from '@/composables/http';
    import { onMounted, ref, computed } from 'vue';
    import { useRoute } from 'vue-router';

    import InvoiceCard from '@/components/InvoiceCard.vue';
    import CheckoutModal from '@/components/modals/CheckoutModal.vue'
    const route = useRoute();
    const showCheckoutModal = ref(false)
    const checkoutType = ref('subscription')
    const checkoutData = ref({
        name: '',
        price: 0   
    })

    const invoices = ref([]);


    function getSubscriptionPlans() {
        window.$http.request("get", "/api/site/subscriptionplans").then((res) => {

            if (res?.Type == 200) {
                subscriptionPlans.value = res.Data;
            }
        });
    }
    function getSubscriptionQuotas() {
        window.$http.request("get", "/api/site/subscriptionquotas").then((res) => {

            if (res?.Type == 200) {
                subscriptionQuotas.value = res.Data;
            }
        });
    }

    function getInvoices() {
        window.$http.request("post", "/api/app/billing/invoices", pagination.value).then((res) => {

            if (res?.Type == 200) {
                invoices.value = res.Data.Rows;
            }
        });
    }

    function downloadInvoice(invoiceId) {

        window.open(apiUrl(`/api/app/billing/invoicepdf?id=${invoiceId}`), '_blank');
    }

    const metadata = ref();

    onMounted(() => {
      
        window.$core.reloadUserInfo(data => {
            metadata.value = data.Metadata;

        });
        getInvoices();
        getSubscriptionPlans();
        getSubscriptionQuotas();

        checkKey();

    });

    const columns = ref([
        {
            title: 'Invoice #', key: 'InvoiceNumber', align: 'center', render(row) {
                return <a href="javascript:void(0)" onClick={() => downloadInvoice(row.Id)}>{row.InvoiceNumber}</a>
            }
        },
        {
            title: 'Date Issued', key: 'Created', align: 'center', render(row) {
                return <span>{toDateFormat(row.CreatedTime, 'MMM D, YYYY')} </span>
            }
        },
        {
            title: 'Description', key: 'plan', align: 'center', render(row) {
                return <span>{row.Transaction?.Description}</span>
            }
        },
        {
            key: 'Amount', title: "Amount", width: 130, render: row => {
                const colorClass = row.Transaction?.Total >= 0 ? 'color-green-700' : 'color-red-600';
                return <span class={colorClass}> ${row.Transaction?.Total} {row.Transaction?.Refund > 0 && (<span style="color:red" > (-${row.Transaction?.Refund})</span>)}</span>;
            }
        },
        {
            key: 'status', title: "", width: 130, align: 'center', render: row => {
                const status = row.Transaction?.Status;
                const statusStr = row.Transaction?.StatusStr;

                let tagType, tipContent;

                if (status === 1) {
                    tagType = 'success';
                    tipContent = 'This payment is complete.';
                } else if (status === 3 || status === 4) {
                    tagType = 'info';
                    tipContent = status === 3 ? 'This refund has been initiated.' : `$${row.Transaction?.Refund} refund was initiated.`;
                } else {
                    tagType = 'error';
                    tipContent = 'Payment failed or was canceled';
                }

                return (
                    <n-tooltip trigger="hover" placement="top" v-slots={{
                        default: () => tipContent,
                        trigger: () => (
                            <n-tag type={tagType} size="small"  >
                                {statusStr === 'Succeeded' ? 'Paid' : statusStr}
                            </n-tag>
                        )
                    }}>
                    </n-tooltip>
                );
            }
        },
    ])


    const pagination = ref({
        pageIndex:1,
        pageSize: 10
    });

    const handlePageChange = (page) => {
        pagination.value.pageIndex = page;
        getInvoices();
    };

    const onUpgradeNow = () => {
        window.scrollTo({ top: 999, behavior: 'smooth' });
    }

   
    const showSwitchPlanDialog = ref(false);
    const showCurrentPlanDialog = ref(false);
    const showCancelSubscriptionDialog = ref(false);
    const dialogMessage = ref("");
    const settings = ref(null);
    const subscriptionPlans = ref([]);
    const subscriptionQuotas = ref([]);

    const selectedPlan = ref(null);

    const upgradePlanLoading = ref(false);
    const switchPlanLoading = ref(false);
    const cancelSubscriptionLoading = ref(false);

    function handleApplyPromoCode(code) {
        if (checkoutType.value == 'subscription') {
            upgradePlan(selectedPlan.value, code);

        } else {
            console.log("Checkout type is not subscription, cannot apply promo code.");
        }
    }

    function upgradePlan(plan, code) {
        selectedPlan.value = plan;
        checkoutType.value = 'subscription'
        checkoutData.value = {
            type: plan.Type
        }
;
        showCheckoutModal.value = true
    }

    
    function switchPlan(plan) {

        selectedPlan.value = plan;
        showSwitchPlanDialog.value = true;
    }

    function switchPlanConfirmed() {
       
        switchPlanLoading.value = true;
        const data = {
            type: selectedPlan.value.Type
        };
        window.$http.request("post", "/api/app/billing/changesubscriptionplan", data).then((res) => {
            if (res?.Type == 200) {
                showSwitchPlanDialog.value = false;
                getInvoices();
                window.$core.reloadUserInfo(data => {
                    metadata.value = data.Metadata;
                });
            }
            switchPlanLoading.value = false;
        });
    }

    const cancelSubscriptionForm = ref({
        Reason:null
    });
    function cancelSubscription() {
        cancelSubscriptionLoading.value = true;
       
        window.$http.request("post", "/api/app/billing/cancelsubscription", cancelSubscriptionForm.value).then((res) => {
            if (res?.Type == 200) {
                showCancelSubscriptionDialog.value = false;
                showCurrentPlanDialog.value = false;
                window.$core.reloadUserInfo(data => {
                    metadata.value = data.Metadata;
                });
            }
            cancelSubscriptionLoading.value = false;
        });
    }
    function resumeSubscription() {
        cancelSubscriptionLoading.value = true;

        window.$http.request("post", "/api/app/billing/resumesubscription").then((res) => {
            if (res?.Type == 200) {
                showCancelSubscriptionDialog.value = false;
                showCurrentPlanDialog.value = false;
                window.$core.reloadUserInfo(data => {
                    metadata.value = data.Metadata;
                });
            }
            cancelSubscriptionLoading.value = false;
        });
    }


    function topup(type) {
        checkoutType.value = 'topup'
        checkoutData.value = {
            type: type
        }
        showCheckoutModal.value = true
    }

    function shareCode() {
        const title = "Hello I've been using this website called Contractly.ca and I think you would be interested in it as well. Please have a look.";
        const body = `It's a website that allows Tradesmen and Building Contractors to generate service contracts quickly and efficiently to send to their clients and subcontractors.� 
        Have a look!! and if you are interested in signing up yourself, please use the following Promo Code ${metadata.value.Referral.Code} to receive ${metadata.value.Referral.Discount} off your subscription.`;

        window.open(`mailto:?subject=${title}&body=${body}`);
    }

    function checkKey() {
        const key = route.query.key;
        if (key != null) {
            window.$http.request("get", "/api/common/readkey", { key }).then(data => {
                console.log("key", data);
           
                if (data?.Title == "Payment Successful") {
                    window.$dialog.success({
                        title: data.Title,
                        closable: false,
                        content: data.Content,
                        positiveText: 'OK',
                        onPositiveClick: () => {
                            window.$router.push('/MyProjects');
                        },
                    })
                }

            });
        }
    }

    const filteredsubscriptionPlans = () => {
       // console.log(subscriptionPlans.value);

        if (metadata.value.Subscription.Plan.Type >1) {
            return subscriptionPlans.value.filter(m => m.Type != 1);
        }
        return subscriptionPlans.value;
    }
</script>

<template>
    <div class="wrapper" style="background-color:#fff;">

        <Sidebar />

        <div class="container container-fix" :style="{ 'margin-left': sidebarWidth }">
            <div class="col-12 ">
                <div class="top" style="height:60px;"> </div>

                <h4 class="mb-6 font-semibold">My Subscription</h4>

                <div class="bg-gray-100 min-h-screen flex flex-col p-4 rounded-xl" v-if="metadata!=null">

                    <!-- Main Subscription Info -->
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4">
                        <!-- Left Column: Plan Details -->
                        <div class=" p-4 rounded ">

                            <div class="space-y-3">
                                <p class="flex items-center">
                                    <span class="w-[45%] font-medium">Current Plan:</span>
                                    <strong>{{metadata.Subscription.Plan.Name}}</strong>
                                </p>

                                <p class="flex items-center" v-if="metadata.Subscription.Status!=1">
                                    <span class="w-[45%] font-medium">{{metadata.Subscription.EndTimeTitle}}:</span>
                                    <strong>{{toDateFormat(metadata.Subscription?.EndTime, 'MMM D, YYYY')}}</strong>
                                </p>

                                <p class="flex items-center">
                                    <span class="w-[45%] font-medium">Subscription Status:</span>
                                    <n-tag :type="metadata.Status === 0 ? 'success' : 'error'" size="medium" round>
                                        {{metadata.StatusStr}}
                                    </n-tag>
                                </p>
                                <div v-if="metadata.CanceledDate != null" class="bg-yellow-50 p-3 text-sm rounded text-yellow-700">
                                    Your subscription will end on <strong>{{metadata.CanceledDate}}</strong>.<br>
                                    You will continue to enjoy full access until this date.
                                </div>
                            </div>
                        </div>

                        <!-- Right Column: Additional Data -->
                        <div class="p-4 rounded ">
                            <div class="text-[12px]">
                                Refer a friend. They get <span class="text-green-600">{{metadata.Referral.Discount}} off</span> and you earn <span class="text-green-600">{{metadata.Referral.Reward}}</span> credit when they sign up.
                            </div>
                            <div class="space-y-3 mt-2">

                                <p class="flex items-center">
                                    <span class="w-40 font-medium">Referral Code:</span>

                                    <n-input-group class="!w-[200px]">
                                        <n-input :value="metadata.Referral.Code" :readonly="true" />
                                        <n-button ghost @click="shareCode">
                                            Share
                                        </n-button>
                                    </n-input-group>
                                </p>

                                <p class="flex items-center">
                                    <span class="w-40 font-medium">Credit Earned:</span>
                                    <span class="text-green-600">${{metadata.Referral.Credits}}</span>
                                </p>


                            </div>
                        </div>
                    </div>

                    <!-- Plans -->
                    <div :class="[' gap-4 mt-10 mb-10',metadata.Subscription.Plan.Type === 0 || true ? 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3' : 'flex justify-center flex-wrap']" v-if="metadata.Subscription.Plan.Type!=9">

                        <div class="bg-white p-6 rounded-lg shadow-sm border" v-for="obj in filteredsubscriptionPlans()" :key="obj.Id">

                            <h3 class="text-lg font-bold" v-if="obj.Type == 1">{{obj.TrialDays}}-Day {{obj.Name}}</h3>
                            <h3 class="text-lg font-bold" v-if="obj.Type != 1">{{obj.Name}}</h3>
                            <div class="mt-2">
                                <template v-if="obj.Type == 1">
                                    <p class="text-lg"><strong>Start Date:</strong> {{metadata.TrialStartDate}}</p>
                                    <p><strong>Expiration Date:</strong> {{metadata.TrialEndDate}}</p>
                                </template>
                                <template v-if="obj.Type != 1">
                                    <p class="text-lg"><strong>{{obj.PriceStr}}</strong></p>
                                    <p>Billed {{obj.Type==2?'Monthly':obj.Type==3?'Annually':'-'}}</p>

                                </template>
                                <n-button strong secondary class="text-white bg-black mt-2 !w-full hover:!bg-gray-500" v-if="metadata.Subscription.Plan.Type == obj.Type" @click="showCurrentPlanDialog = true" :disabled="metadata.Subscription.Plan.Type==1">Current Plan</n-button>
                                <n-button strong secondary class="text-white bg-black mt-2 !w-full hover:!bg-gray-500" v-else-if="(metadata.Subscription.Plan.Type == 0 || metadata.Subscription.Plan.Type == 1) && obj.Type!=1" @click="upgradePlan(obj)" :loading="upgradePlanLoading">Upgrade Plan</n-button>
                                <n-button strong secondary class="text-white bg-black mt-2 !w-full hover:!bg-gray-500" v-else-if="metadata.Subscription.Plan.Type < 9 && obj.Type!=1" @click="switchPlan(obj)" :loading="switchPlanLoading">Switch Plan</n-button>
                                <n-button strong secondary class="text-white bg-black mt-2 !w-full hover:!bg-gray-500" v-else disabled>{{metadata.StatusStr}}</n-button>
                            </div>

                            <ul class="mt-4 space-y-2 text-sm list-none !max-w-[310px]">
                                <li class="flex items-start">
                                    <span class="text-green-600 font-bold mr-1">&#10003;</span>
                                    <span v-html="obj.Line1"></span>
                                </li>
                                <li class="flex items-start">
                                    <span class="text-green-600 font-bold mr-1">&#10003;</span>
                                    <span v-html="obj.Line2"></span>
                                </li>
                                <li class="flex items-start">
                                    <span class="text-green-600 font-bold mr-1">&#10003;</span>
                                    <span v-html="obj.Line3"></span>
                                </li>
                            </ul>
                        </div>


                        <div class="bg-white p-6 rounded-lg shadow-sm border" v-if="metadata.Subscription.Plan.Type == 2 || metadata.Subscription.Plan.Type == 3">
                            <h3 class="text-lg font-bold">Top-Up</h3>
                            <p>Need Additional Agreements This Billing Cycle?</p>

                            <div class="space-y-4">
                                <div class="bg-gray-50 !p-3 rounded border border-gray-200" v-for="obj in subscriptionQuotas" :key="obj.Id">
                                    <div class="flex justify-between items-center">
                                        <span class="font-semibold text-gray-700">{{obj.Name}}</span>
                                        <span class="font-bold text-indigo-600">{{obj.PriceStr}}</span>
                                    </div>
                                    <n-button strong secondary class="text-white bg-black mt-2 !w-full hover:!bg-gray-500" @click="topup(obj.Type)" :loading="upgradePlanLoading">
                                        Buy Now
                                    </n-button>
                                    <div class="flex items-start text-gray-600 text-sm mt-2">
                                        <span class="text-green-600 font-bold mr-1">&#10003;</span>
                                        <span>That's <span style="color:red;">$10</span> per Agreement</span>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>

                    <!-- Invoice Table -->
                    <div class="mt-8 ">
                        <h2 class="text-lg font-bold">Invoices</h2>
                        <n-data-table :columns="columns" :data="invoices" class="mt-4 invoice-table" :pagination="pagination" @update:page="handlePageChange"></n-data-table>

                    </div>

                </div>
            </div>
        </div>

        <CheckoutModal v-model:show="showCheckoutModal" :type="checkoutType" :data="checkoutData" @apply-promoCode="handleApplyPromoCode" @submit="handlePaymentSubmit" />

        <n-modal v-model:show="showSwitchPlanDialog" preset="card" title="Switch Plan" style="width: 90%; max-width: 500px" :maskClosable="false">
            <div class="bg-gray-50 dark:bg-gray-800 p-3 rounded text-center">
                <p>You're about to switch to <b>{{selectedPlan.Name}} plan</b>.</p>
                <p>Your new plan will take effect on your next billing date.</p>
                <div><strong>Do you want to continue with this change?</strong></div>
            </div>

            <div class="flex justify-center mt-4 pb-4 gap-4">
                <n-button @click="showSwitchPlanDialog=false;" class="w-[100px]" type="default">Cancel</n-button>
                <n-button @click="switchPlanConfirmed" class="w-[100px]" type="primary" :loading="switchPlanLoading">Confirm</n-button>
            </div>
        </n-modal>
        <n-modal v-model:show="showCancelSubscriptionDialog" preset="card" title="Cancel Subscription" style="width: 90%; max-width: 500px" :maskClosable="false">
            <div class="bg-gray-50 dark:bg-gray-800 p-3 rounded">
                <div class="mb-2 text-center">
                    <p class="mb-3">Your subscription will remain active until <strong>{{toDateFormat(metadata.Subscription?.EndTime, 'MMM D, YYYY')}}</strong>.</p>
                    <p class="text-gray-600 dark:text-gray-400 text-sm">You'll continue to have full access until then.</p>
                    <div><strong>Do you want to continue with this change?</strong></div>
                </div>

                <n-input v-model:value="cancelSubscriptionForm.Reason"  type="textarea"  placeholder="Reason" class="mt-2" :autosize="{ minRows: 2 }" />
            </div>

            <div class="flex justify-center mt-4 pb-4 gap-4">
                <n-button @click="showCancelSubscriptionDialog=false;" class="w-[100px]" type="default">Cancel</n-button>
                <n-button @click="cancelSubscription" class="w-[100px]" type="primary" :loading="cancelSubscriptionLoading">Confirm</n-button>
            </div>
        </n-modal>

        <n-modal v-model:show="showCurrentPlanDialog" preset="card" title="Current Plan" style="width: 90%; max-width: 500px" :maskClosable="false">
            <div class="bg-gray-50 dark:bg-gray-800 p-3 rounded">
                <div><b class="mr-2">Plan Type:</b> {{metadata.Subscription?.Plan?.Name}}</div>
                <div><b class="mr-2">{{metadata.Subscription?.EndTimeTitle}}:</b> {{toDateFormat(metadata.Subscription?.EndTime, 'MMM D, YYYY')}}</div>
                <div>
                    <b class="mr-2">Subscription Status:</b>
                    <n-tag :type="metadata.Status === 0 ? 'success' : 'error'" size="small" round>
                        {{metadata.Subscription?.StatusStr}}
                    </n-tag>
                </div>
                <div><b class="mr-2">Template Quota:</b> {{metadata.Subscription?.TemplateQuota}}</div>
                <div><b class="mr-2">Client Agreements Quota:</b> {{metadata.Subscription?.ClientContractQuota}}</div>
                <div><b class="mr-2">Sub-Contractor Agreements Quota:</b> {{metadata.Subscription?.SubcontractorContractQuota}}</div>
            </div>

            <div class="flex justify-center mt-4 pb-4 gap-4">
                <n-button @click="showCancelSubscriptionDialog=true" type="default" v-if="metadata.Subscription?.Status==0">Cancel Subscription</n-button>
                <n-button @click="resumeSubscription" type="default" v-if="metadata.Subscription?.Status==2">Resume Subscription</n-button>
                <n-button @click="upgradePlan(subscriptionPlans.find(m=>m.Type==2))" type="primary" v-if="metadata.Subscription?.Status==1">Upgrade Plan</n-button>
            </div>
        </n-modal>
    </div>
   
</template>
<style scoped>
    ul{list-style:none;margin-left:-30px;font-size:13px;}

    .invoice-table { display: block;  }

         
    .invoice-card { display: none; }

    /* Responsive Styles */
    @media (max-width: 768px) {
        .invoice-table {
            display: none; /* Hide table for mobile */
        }

         
        .invoice-card {
            display: block;
        }
 
    }

</style>


